export default __webpack_public_path__ + "static/media/LogoRipley.3607b16f.svg";